import React from "react";
import { Badge as ChakraBadge } from "@chakra-ui/react";
export function UpsellBadge(props) {
    return React.createElement(ChakraBadge, { variant: "upsell", ...props });
}
